export const IntranetAbsenceRequest = {
    path: '/intranet_absence_requests',
    name: 'intranet_absence_requests',
    component: () => import('@/views/Intranet/IntranetAbsenceRequestPage.vue'),
    children: [
        {
            path: '/intranet_absence_requests/add',
            name: 'intranet_absence_requests.add',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {addAction: true, intranet: true}
        },
        {
            path: '/intranet_absence_requests/edit/:id',
            name: 'intranet_absence_requests.edit',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {updateAction: true, intranet: true}
        },
        {
            path: '/intranet_absence_requests/delete/:id',
            name: 'intranet_absence_requests.delete',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {deleteAction: true, intranet: true}
        },
        {
            path: '/intranet_absence_requests/view/:id',
            name: 'intranet_absence_requests.view',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {viewAction: true, intranet: true}
        },
        {
            path: '/intranet_absence_requests/set_decision/:id/:module',
            name: 'intranet_absence_requests.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/intranet_absence_requests/timelines/:id/:module',
            name: 'intranet_absence_requests.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/intranet_absence_requests/documents/:id',
            name: 'intranet_absence_requests.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "ABSENCE_REQUEST"}
        },
    ]
}